module.exports = __webpack_public_path__ + "static/Mephit-693ee7956d032b74fe239a4bdbf831a0.jpg";